// extracted by mini-css-extract-plugin
export default {"con":"index_con_fEF0S","ad":"index_ad_9HBar"};